<template>
    <star-rating
        @rating-selected="$emit('input', $event)"
        :rating="rating"
        :show-rating="false"
        :star-size="40"
        active-color="#000"
        inactive-color="#DDE2E6"
        :inline="inline"
        
    />
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
    components: {
        StarRating
    },
    props: {
        rating: {
            type: Number
        },
        value: {
            type: Number
        },
        inline: {
            type: Boolean,
            default: false
        }
    }
};
</script>
